<div class="modal-header">
  <h3 class="modal-title" i18n="@@scratchpadViewer" id="supplement-modal-header">
    Scratchpad Viewer
  </h3>
  <button
    type="button"
    class="close"
    i18n-aria-label
    aria-label="Close Scratchpad Viewer"
    ngbAutoFocus
    (click)="close()"
    (keydown.enter)="close()"
    (keydown.space)="close()"
  >
    <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
  </button>
</div>
<div class="modal-body" id="mi-details">
  <p>
    <strong>Basket Ref: {{ basketRef }}</strong>
  </p>
  @if (loading) {
    <div class="relative-container loading-container" aria-live="polite">
      <app-loading-spinner size="sm" message="Loading notes..."></app-loading-spinner>
    </div>
  }
  @if (!loading) {
    <div class="saved-note-container">
      <!-- list of availbale notes -->
      @for (note of savedNotes; track note) {
        <div class="saved-note">
          <p>
            <strong>{{ note.createdAt | sabsDate: 9 }}</strong
            >&nbsp;
            {{ note.agent.email }}
          </p>
          <p>
            {{ note.note }}
          </p>
        </div>
      }
    </div>
  }

  <!-- new entries -->
  <div>
    <label for="new-scratchpad-note">Add a new Scratchpad entry</label>
    <textarea
      id="new-scratchpad-note"
      style="width: 100%"
      rows="5"
      maxlength="5000"
      [(ngModel)]="newNote"
    >
    </textarea>
  </div>
</div>
<div class="modal-footer">
  <div class="relative-container">
    <button
      type="button"
      id="button_ok"
      appButton="small"
      aria-label="Save and Continue"
      i18n-aria-label
      aria-live="polite"
      [disabled]="!valid() || saving"
      (click)="submit()"
      (keydown.enter)="submit()"
      (keydown.space)="submit()"
    >
      @if (!saving) {
        <span i18n="@@Save"> Save </span>
      }
      @if (saving) {
        <span><i class="button_spinner input-loading-spinner-left"></i></span>
      }
    </button>
  </div>
</div>
